import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SiteFooter() {
  return <footer className="border-t border-stone-200 bg-[#172820] text-[#f8f7f3]" data-id="element-140" data-mp="3r9kk9h7qwhbr">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-10 sm:px-8 md:flex-row md:items-end md:justify-between lg:px-10" data-id="element-141" data-mp="3mgrfwug6vb07">
        <div data-id="element-142" data-mp="3hi6c6l1qa970">
          <Link to="/" className="text-lg font-semibold tracking-tight" style={{
          fontFamily: 'var(--font-display)'
        }} data-id="element-143" data-mp="3hgls5pd1i8ne">
            Daanish
          </Link>
          <p className="mt-2 max-w-sm text-sm leading-6 text-stone-300" data-id="element-144" data-mp="33i59r15tetpf">
            CRM systems designed to bring more clarity to customer growth.
          </p>
        </div>
        <Link to="/contact" className="group inline-flex items-center gap-2 text-sm font-semibold text-[#a8d5c3] transition-colors hover:text-white" data-id="element-145" data-mp="2ylyblujnumi1">
          Start a project{' '}
          <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-146" data-mp="15r504t1xn0nj" />
        </Link>
      </div>
    </footer>;
}